// CountDown Clock
// Version   : 1.0.2
// Developer : Ekrem KAYA
// Website   : https://e-piksel.com
// GitHub    : https://github.com/epiksel/countdown

(function ($) {
	$.fn.countdowneliving = function (options, callback) {
		var settings = $.extend({
			date: null,
			offset: null,
			day: 'Day',
			days: 'Days',
			hour: 'Hour',
			hours: 'Hours',
			minute: 'Minute',
			minutes: 'Minutes',
			second: 'Second',
			seconds: 'Seconds',
			hideOnComplete: false
		}, options);

		// Throw error if date is not set
		if (!settings.date) {
			$.error('Date is not defined.');
		}

		// Throw error if date is set incorectly
		if (!Date.parse(settings.date)) {
			$.error('Incorrect date format, it should look like this, 12/24/2012 12:00:00.');
		}

		// Save container
		var container = this;

		/**
		 * Change client's local date to match offset timezone
		 * @return {Object} Fixed Date object.
		 */
      
		var currentDate = function () {
			// get client's current date
			var date = new Date();

			// turn date to utc
			var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

			// set new Date object
			var new_date = new Date(utc + (3600000*settings.offset));

			return new_date;
		};
      

		/**
		 * Main countdown function that calculates everything
		 */
		function countdowneliving() {
			//console.log('saasa pppppp');
            var target_date = new Date(settings.date), // set target date
				current_date = currentDate(); // get fixed current date
                // current_date = current_date.setHours(currentDate.getHours() + 2);
          // target_date.setHours(0, 0, 0, 0);
// console.log('************')
//           console.log(target_date)
//           console.log(current_date)
//           console.log('************')
			// difference of dates
			var difference = target_date - current_date;
            // console.log('##########')
            // console.log(difference)
            // console.log('##########')
          // var difference = difference + (2 * 60 * 60 * 1000);
          var difference = difference;

// console.log(difference);
			// if difference is negative than it's pass the target date
			if (difference < 0) {
				// stop timer
				clearInterval(interval);

				if (settings.hideOnComplete) {
					$(container).hide();
				}

				if (callback && typeof callback === 'function') {
					callback(container);
				}

				return;
			}

			// basic math variables
			var _second = 1000,
				_minute = _second * 60,
				_hour = _minute * 60,
				_day = _hour * 24;

			// calculate dates
			var days = Math.floor(difference / _day),
				hours = Math.floor((difference % _day) / _hour),
				minutes = Math.floor((difference % _hour) / _minute),
				seconds = Math.floor((difference % _minute) / _second);
            // console.log(days+'/////')
			// based on the date change the refrence wording
			var text_days = (days === 1) ? settings.day : settings.days,
				text_hours = (hours === 1) ? settings.hour : settings.hours,
				text_minutes = (minutes === 1) ? settings.minute : settings.minutes,
				text_seconds = (seconds === 1) ? settings.second : settings.seconds;

				// fix dates so that it will show two digets
				days = (String(days).length >= 2) ? days : '0' + days;
				hours = (String(hours).length >= 2) ? hours : '0' + hours;
				minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes;
				seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds;
				if(days == '0' ){
					$('.eliving-day').hide();
				}else{
					$('.eliving-day').show();
				}
			// set to DOM
          if (difference < 0) {
            $('#countdownClearance_bar').hide();
          }else{
            $('#countdownClearance_bar').show();
            $('#countdownClearance_bar').find('.days').text(days);
			$('#countdownClearance_bar').find('.hours').text(hours);
			$('#countdownClearance_bar').find('.minutes').text(minutes);
			$('#countdownClearance_bar').find('.seconds').text(seconds);
          }
          // console.log('2999999999999999')
			container.find('.days').text(days);
			container.find('.hours').text(hours);
			container.find('.minutes').text(minutes);
			container.find('.seconds').text(seconds);

			container.find('.days_text').text(text_days);
			container.find('.hours_text').text(text_hours);
			container.find('.minutes_text').text(text_minutes);
			container.find('.seconds_text').text(text_seconds);
``
            $('#countdownCart').find('.days').text(days);
            $('#countdownCart').find('.hours').text(hours);
            $('#countdownCart').find('.minutes').text(minutes);
            $('#countdownCart').find('.seconds').text(seconds);

		}

		// start
		var interval = setInterval(countdowneliving, 1000);
	};

})(jQuery);

jQuery(".collection_product_color_swatches ul li").click(function () {
    var dataimage = $(this).attr("data-img");
    jQuery(this).closest('.bestseller_product').find('img.motion-reduce').attr('srcset',''); 
     jQuery(this).closest('.bestseller_product').find('img.motion-reduce').attr('src',dataimage);  
 
    //alert(imgsrc);
  //$(this).attr('src', $(this).data("hover"));
  }).mouseout(function () {
    //$(this).attr('src', $(this).data("src"));
  });